import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateTagComponent } from './create/create-tag.component';
import { ViewTagsComponent } from './view/view-tags.component';
import { SelectTagsComponent } from './select/select-tags.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CreateTagComponent,
    ViewTagsComponent,
    SelectTagsComponent
  ],
  exports: [
    CreateTagComponent,
    ViewTagsComponent,
    SelectTagsComponent
  ]
})
export class TagsModule { }



// WEBPACK FOOTER //
// ./client/app/shared/tags/tags.module.ts